/* @ngInject */

export default (
  $rootScope,
  $scope,
  webpage,
  organizationService,
  changesService,
  OrganizationEnterprise,
  OrganizationPermissions,
  uiService
) => {
  $scope.Model = {
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  if ($rootScope.CurrentAccount.isAdministrator) {
    organizationService
      .readOrganization({ id: $rootScope.CurrentOrganization.id })
      .then(function (data) {
        // Overwrite $rootScope values in case they've reverted to values within Token
        $rootScope.CurrentOrganization.enterprise = OrganizationEnterprise.build(
          data.enterprise
        );
        $rootScope.CurrentOrganization.permissions = OrganizationPermissions.build(
          data.permissions
        );
      })
      .then(function () {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Permissions : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.toggleChanges = function () {
    changesService.change();
  };
  $scope.togglePermission = function (privilege, level) {
    uiService.scopeApply(function () {
      $rootScope.CurrentOrganization.permissions[privilege].owner = true;
      switch (level) {
        case 0:
          $rootScope.CurrentOrganization.permissions[privilege].team = false;
          $rootScope.CurrentOrganization.permissions[privilege].organization = false;
          break;
        case 1:
          $rootScope.CurrentOrganization.permissions[privilege].organization = false;
          break;
        case 2:
          $rootScope.CurrentOrganization.permissions[privilege].team =
            $rootScope.CurrentOrganization.permissions[privilege].organization;
          break;
        default:
          break;
      }
      $scope.toggleChanges();
    });
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);

  function saveChanges() {
    var organizationData = {
      id: $rootScope.CurrentOrganization.id,
      permissions: $rootScope.CurrentOrganization.permissions
    };
    return organizationService.updateOrganization(organizationData).then(function (result) {
      if (result.status) {
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  }
};
